import { Component, Inject, HostListener } from '@angular/core';
import { Router ,ActivatedRoute } from '@angular/router';
import { NavigateUrlService } from '../shared/services/navigate-url.service';
import { RestApiService } from '../shared/restApiServices/restapi.service';
import { SelectedQnrService } from '../shared/services/selected-qnr.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { superAdminService } from '../shared/services/superAdminService';
import { TabsDataService } from '../shared/services/tabs-data.service';
import { tutorialComponent } from '../tutorial/tutorialComponent'
declare var amplitude:any;


@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['dashboard.component.css']
})

export class DashboardComponent {

  temp: number;
  showManagerTab: boolean;
  user = "User";
  notSupportedSize: boolean;
  rightPanel: boolean;
  Tabs =
    {
      'questionnaires' : 0,
      'data-analysis':0,
      'survey-data':0,
      'Surveyors' : 1,
      'groups' :2,
      'analytics-data' : 4,
      'manager-data' : 5
    };

  closeMenu;

  constructor(private router: Router, private navigateUrlService: NavigateUrlService, public dialog: MatDialog, private restApiService: RestApiService, private selectedQnrService: SelectedQnrService, private superAdminService: superAdminService, private tabsDataService:TabsDataService,private route:ActivatedRoute) {
    if (window.screen.width < 900) {
      // console.log("Scree size not supported");
      this.notSupportedSize = true;
    }
    else {
      this.notSupportedSize = false;
    }
    this.rightPanel = false;

    this.route.url.subscribe(res=>{
      this.temp = this.Tabs[res[0]['path']];
      if(this.temp == undefined)
      {
        this.temp = 0;
      }
    });

    let browserStorage = localStorage.getItem('browserStorage');
    if (browserStorage != undefined && browserStorage != null) {
      let accessToken = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
      if (accessToken != undefined || accessToken != '') {

        this.restApiService.getadminStatus().subscribe(
          result => {
            if (result.length > 0) {
              let dialogRef = this.dialog.open(InviteManagerComponent, {
                height: '440px',
                width: '800px',
                data: result
              });
              dialogRef.afterClosed().subscribe(result => {
              });
            }
          });

        if (this.superAdminService.hasData()) {
          this.showManagerTab = this.superAdminService.getData();
        } else {
          this.restApiService.checkIfSuperAdmin().subscribe(
            result => {
              if (result.checkIfSuperAdmin == true) {
                this.showManagerTab = true;
                this.superAdminService.setData(this.showManagerTab);
              }
              else {
                this.showManagerTab = false;
                this.superAdminService.setData(this.showManagerTab);
              }
            });
        }
      }
    }

    this.closeMenu = this.superAdminService.closeMenu.subscribe(response=>{
      if(response && response == "close"){
        this.rightPanel = false;
      }
    })
  }

  ngOnInit() {
    this.user = localStorage.getItem("user_name_header");
    this.navigateUrlService.navigateToUrl('', '/home');//params:successpath, failpath
    // this.router.navigateByUrl('/questionnaires');
  }

  showRightPanel() {
    this.rightPanel = !this.rightPanel;
  }
  gotoProfile(){
    this.router.navigateByUrl('/userProfile');//params:successpath, failpath
  }

  showTutorial(){
    let dialogRef = this.dialog.open(tutorialComponent, {
      height: '82%',
      width: '76%'
    });
    dialogRef.afterClosed().subscribe(result => {
      this.rightPanel = false;
    });
  }

  gotoview(value: number) {

    switch (value) {

      case 0:
        this.router.navigateByUrl('/questionnaires');
        amplitude.getInstance().logEvent('Formstabclicked');
        this.restApiService.goToSurveys.next(true);
        break;
      case 1:
        this.router.navigateByUrl('/Surveyors');
        amplitude.getInstance().logEvent('Surveyorstabclicked');
        break;
      case 2:
        this.router.navigateByUrl('/groups');
        amplitude.getInstance().logEvent('Teamstabclicked');
        break;
      case 3:
        this.router.navigateByUrl('/survey-data');
        amplitude.getInstance().logEvent('Responsestabclicked');
        break;
      case 4:
        this.router.navigateByUrl('/analytics-data');
        amplitude.getInstance().logEvent('DataAnalyticstabclicked');
        break;
      case 5:
        this.router.navigateByUrl('/manager-data');
        amplitude.getInstance().logEvent('Managertabclicked');
        break;
    }
  }

  signOut() {

    this.restApiService.signOutService().subscribe(
      result => {
        // if (result.success) {
          this.superAdminService.setData(undefined);
          this.selectedQnrService.setQnr(null,null);
          localStorage.removeItem('browserStorage');
          localStorage.removeItem('superAdminID');
          localStorage.removeItem('username');
          localStorage.removeItem('user_name_header');
          this.tabsDataService.setSurveyTabDataTobeUpdated(true);
          this.tabsDataService.setSurveyorDataTobeUpdated(true);
          this.tabsDataService.setTeamsTabDataTobeUpdated(true);
          this.tabsDataService.setDateLevelAnalyticsDataTobeUpdated(true);
          this.tabsDataService.setDateUserAnalyticsDataTobeUpdated(true);
          this.router.navigateByUrl('/logIn');
        // }
        // else {
        //   localStorage.removeItem('browserStorage');
        //   this.router.navigateByUrl('/logIn');
        // }
      });
  }

  openSettings(){
    this.router.navigateByUrl('/userProfile');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 900) {
      this.notSupportedSize = true;
    }
    else{
      this.notSupportedSize=false;
    }
    // event.target.innerWidth;

  }

  createNewForm(){
    this.router.navigate(['./questionnaires'], {
      queryParams: {
        'createHr': true,
      },
      queryParamsHandling: 'merge'
    });
  }
}

@Component({
  selector: 'invite-dialog',
  templateUrl: 'invite-dialog.html',
  // styleUrls: ['invite-dialog.css']
})
export class InviteManagerComponent {
  superAdminName: string;
  companyName:string;

  constructor(public dialogRef: MatDialogRef<InviteManagerComponent>, public restApiService: RestApiService, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.superAdminName = this.data[0].adminName;
    this.companyName = this.data[0].company_name;
  }

  acceptInvite() {
    // console.log("Accept Invitation");
    let superAdminID = this.data[0].superAdminID;
    this.restApiService.setadminStatus(superAdminID).subscribe(result => {
      if (result.success == true) {
        localStorage.setItem("superAdminID",superAdminID);
        this.dialogRef.close();
        let switchOrg:any = localStorage.getItem('switchOrg');
        if(switchOrg && switchOrg!= undefined){
          switchOrg = JSON.parse(switchOrg);
          if(switchOrg.findIndex(data=>data.superAdminID ==superAdminID ) == -1){
            switchOrg.push({orgName:this.companyName,superAdminID:superAdminID});
            localStorage.setItem('switchOrg',JSON.stringify(switchOrg));
          }
        }
        this.restApiService.orgName.next(this.companyName);
      }
    });
  }

  declinerequest() {
    // console.log("Decline Invitation");
    var superAdmin = this.data[0].superAdminID;
    this.restApiService.declineInviteRequestforManager(superAdmin).subscribe(result => {
      if (result.success == true) {
        this.dialogRef.close();
      }
    });
  }
  onClose(){
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts